<template>
    <div>
        <div class="modal fade" id="fontModal" tabindex="-1" role="dialog" aria-labelledby="fontModalLabel"
             aria-hidden="true">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="fontModalLabel">Fonts</h5>
                        <button type="button" class="btn-close" @click="noHandler" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">

                        <div class="row">
                            <div class="col-4">
                                <h3>Fonts</h3>

                                <div class="list-group" style="height: 500px; overflow-y: scroll">
                                    <a v-for="font in model.fonts" href="javascript:void(0)"
                                       @click="onFontClick(font)"
                                       class="list-group-item list-group-item-action pointer">
                                        {{font.family}}
                                    </a>
                                </div>

                            </div>
                            <div class="col-8">

                                <h3>Font Preview: {{currentFont.family}}</h3>

                                <div>
                                    <h3>Header</h3>

                                    <h1 :style="newFontStyle">Build Something Great</h1>

                                    <h3 class="mt-5">Text</h3>

                                    <p :style="newFontStyle">
                                        WeBase is a platform for building custom applications and beautiful websites
                                        without writing code!
                                    </p>
                                </div>

                                <form>

                                    <div class="row mb-3">
                                        <label for="headerFontOptions" class="col-sm-3 col-form-label">Header Font</label>
                                        <div class="col-sm-9">
                                            <select id="headerFontOptions" class="form-select" v-model="website.metadata.headerFont">
                                                <option v-for="font in model.fonts" :value="font.family">{{font.family}}</option>
                                            </select>
                                        </div>
                                    </div>

                                    <div class="row mb-3">
                                        <label for="textFontOptions" class="col-sm-3 col-form-label">Text Font</label>
                                        <div class="col-sm-9">
                                            <select id="textFontOptions" class="form-select" v-model="website.metadata.textFont">
                                                <option v-for="font in model.fonts" :value="font.family">{{font.family}}</option>
                                            </select>
                                        </div>
                                    </div>

                                </form>

                            </div>
                        </div>

                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-danger" @click="yesHandler">Yes</button>
                        <button type="button" class="btn btn-secondary " @click="noHandler">No</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import SiteService from "../services/SiteService";

    export default {
        name: 'FontModal',
        props: {
            yesEvent: Function,
            website: Object
        },
        data() {
            return {
                model: webase.model,
                service: new SiteService(),
                currentFont: {
                    family: 'Raleway'
                },
                currentModal: null,
                modalElement: null,
            }
        },
        computed: {
            newFontStyle() {
                if (this.currentFont.family) {
                    return {
                        fontFamily: this.currentFont.family
                    }
                }

                return {
                    fontFamily: 'Raleway'
                }
            }
        },
        mounted() {
            // add an event to trigger the parent's "noEvent" once the modal has been hidden
            // $('#fontModal').on('hidden.bs.modal', () => {
            //     this.$emit('noEvent')
            // })
            // // show the modal
            // $('#fontModal').modal('show')

            this.modalElement = document.getElementById('fontModal')
            this.currentModal = new bootstrap.Modal(this.modalElement)

            this.modalElement.addEventListener('hidden.bs.modal', this.onModalHidden)

            this.currentModal.show()
        },
        beforeUnmount() {
            // remove the event
            // $('#fontModal').off('hidden.bs.modal')
            this.modalElement.removeEventListener('hidden.bs.modal', this.onModalHidden)
        },
        methods: {
            onModalHidden() {
                this.$emit('noEvent')
            },
            onFontClick(font) {
                this.currentFont = font
                webase.utils.ui.injectFont(font.family)
            },
            noHandler(e) {
                // hide the modal
                this.currentModal.hide()
            },
            yesHandler(e) {
                // call the parent's "yesEvent"
                if (this.yesEvent) {
                    this.yesEvent()
                }

                let request = {
                    website: {
                        metadata: this.website.metadata
                    }
                }

                this.service.update(this.website.slug, request).then((response) => {
                    console.log('Website updated')
                    this.model.website = response
                }).catch((message) => {
                    webase.utils.notification.error(message)
                })

                // hide the modal
                this.noHandler()
            }
        }
    }
</script>
